import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import resume from "../assets/Naivedh's Resume.pdf"
function Navigation(props) {
  return (
    <Navbar id="navbar"  bg="transparent" expand="lg" variant="dark">
      <Navbar.Brand href="#home">NAIVEDH SHAH</Navbar.Brand>
      <Navbar.Toggle style={{color:"white"}} aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link href="#about">About</Nav.Link>
          <Nav.Link href="#projects">Projects</Nav.Link>
          <Nav.Link href="#hackathons">Hackathons</Nav.Link>
          <Nav.Link href="#blogs">Blog</Nav.Link>
          <Navbar.Text> <a href= {resume} target="_blank" rel="noreferrer" download="Naivedh's Resume.pdf">Resume</a></Navbar.Text>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;
